import { useState, useEffect, JSX } from 'react'
import Modal from 'components/Modal'

interface UrlModalProps {
    children: JSX.Element
    onClose: () => void
    title: string
    desc?: string
    loading?: boolean
}

function UrlModal({ children, onClose, title, desc, loading }: UrlModalProps) {
    const [modalOpen, setModalOpen] = useState(false)

    useEffect(() => {
        setModalOpen(true)
    }, [])

    return (
        <Modal open={modalOpen} onClose={onClose} title={title} desc={desc} loading={loading || false}>
            {children}
        </Modal>
    )
}

export default UrlModal
